export var MuiInputAdornment = {
  styleOverrides: {
    positionEnd: function positionEnd(_ref) {
      var theme = _ref.theme;
      return {
        "& .MuiIconButton-edgeEnd": {
          padding: theme.spacing(theme.spaces.main)
        }
      };
    }
  }
};
//# sourceMappingURL=MuiInputAdornment.js.map